import { Dispatch } from "redux";
import { setLoading } from "./global";
import CatalogEthService from "service/CatalogEth";
import { showMessage } from "utilities/helper";
import { CatalogEthPayloadTypes } from "utilities/types/CatalogEth";
import { CatalogDescriptionPayloadTypes } from "utilities/types/CatalogDescription";

export const getAllCatalogsEth =
  (
    page: number = 1,
    search: string = "",
    limit: number = 10,
    filterTenant: number = 3
  ) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    dispatch({
      type: "SET_CATALOG_ETH_CURRENT_PAGE",
      currentPage: page,
    });
    dispatch({
      type: "SET_SEARCH_CATALOG_ETH",
      searchValue: search,
    });

    try {
      const data = await CatalogEthService.getAllCatalogsEth(
        page,
        search,
        limit,
        filterTenant
      );

      dispatch(setLoading(false));
      dispatch({
        type: "SET_CATALOG_ETH",
        value: data.catalogs,
      });
      dispatch({
        type: "SET_CATALOG_ETH_PAGE",
        totalPage: !!data.catalogs.length ? data.last_page : 1,
        limitPage: limit,
        lengthPage: !!data.catalogs.length ? data.total_data : 1,
      });
      dispatch({
        type: "SET_CATALOG_ETH_FILTER_PAGE",
        filterTenantPage: filterTenant,
      });
    } catch (err: any) {
      dispatch(setLoading(false));
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };

export const storeCatalogEth =
  (form: CatalogEthPayloadTypes, handleCloseModal: () => void) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await CatalogEthService.storeCatalogEth(payload);
      const { currentPage, searchValue, limitPage, filterTenantPage } =
        getState().catalogEthReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(
        getAllCatalogsEth(
          currentPage,
          searchValue,
          limitPage,
          filterTenantPage
        ) as any
      );

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const updateCatalogEth =
  (
    catalogId: string,
    form: CatalogEthPayloadTypes,
    handleCloseModal: () => void
  ) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await CatalogEthService.updateCatalogEth(catalogId, payload);
      const { currentPage, searchValue, limitPage, filterTenantPage } =
        getState().catalogEthReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(
        getAllCatalogsEth(
          currentPage,
          searchValue,
          limitPage,
          filterTenantPage
        ) as any
      );

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const deleteCatalogEth =
  (catalogId: string, handleCloseModal: () => void) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    try {
      const data = await CatalogEthService.deleteCatalogEth(catalogId);
      const { currentPage, searchValue, limitPage, filterTenantPage } =
        getState().catalogEthReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(
        getAllCatalogsEth(
          currentPage,
          searchValue,
          limitPage,
          filterTenantPage
        ) as any
      );

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const updateCatalogEthDescription =
  (form: CatalogDescriptionPayloadTypes, handleCloseModal: () => void) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await CatalogEthService.updateCatalogEthDescription(payload);
      const { currentPage, searchValue, limitPage, filterTenantPage } = getState().catalogReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_DESCRIPTION", value: false });

      dispatch(getAllCatalogsEth(currentPage, searchValue, limitPage, filterTenantPage) as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };
